import { h, Component } from 'preact';
import style from './style.css';

export default class Button extends Component {
  render({ onButtonClick, name, image, codespace }) {
    return (
      <button class={`btn ${style['btn-secondary']}`} onClick={onButtonClick}>
        {image && <img src={image} />}
        {codespace}
        <span>{name}</span>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./checkout/components/transparent-button/index.js